﻿jQuery(function () {
  (function ($) {
    ('use strict');
    var SUPPORTED_BROWSERS_PATH =
      window.getAppFolderPath() + '/home/supportedbrowsers';

    // Bootstrap 4 does not support "Proxy Browsers" and calls out specifically the 3 below.
    // Redirect to info page when we don't support the browser or a specific feature that is critical for this app
    var isAmazonSilk =
      /(?:; ([^;)]+) Build\/.*)?\bSilk\/([0-9._-]+)\b(.*\bMobile Safari\b)?/.exec(
        navigator.userAgent
      );
    var isUCBrowser = navigator.userAgent.indexOf(' UCBrowser/') >= 0;
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') >= 0;
    // must test for IE 10 and below differently than IE 11
    var isIE10orBelow =
      $('html').hasClass('ie') ||
      Function('/*@cc_on return document.documentMode===10@*/')();
    var isAtLeastIE11 = !!(
      navigator.userAgent.match(/Trident/) && !navigator.userAgent.match(/MSIE/)
    );

    var isUnsupportedBrowserPage =
      window.location.href.indexOf(SUPPORTED_BROWSERS_PATH) > -1;

    if (
      !isUnsupportedBrowserPage &&
      (isIE10orBelow ||
        isAtLeastIE11 ||
        isAmazonSilk ||
        isUCBrowser ||
        isOperaMini ||
        // START: feature detection
        !Modernizr.flexbox)
    ) {
      // redirect user
      window.location.href =
        SUPPORTED_BROWSERS_PATH + '?isUnsupportedBrowser=true';
    }
  })(jQuery);
});

// This is for Technicians site
window.getAppFolderPath = function getAppFolderPath() {
  return '';
};
